import { IClientConfig } from '@spikemark/core';
import { ServerConfig } from './server-config';

export const ClientConfig: IClientConfig = {
  baseUrl: '',
  version: ServerConfig.version,
  cacheRevalidate: ServerConfig.cacheRevalidate,
  disableCache: ServerConfig.disableCache,
  fetchRequestMaxRetries: ServerConfig.fetchRequestMaxRetries,
  fetchRequestTimeout: ServerConfig.fetchRequestTimeout,
  clerk: {
    publishableKey: ServerConfig.clerk.publishableKey,
  },
  cloudinary: {
    basePath: ServerConfig.cloudinary.basePath,
  },
  googleAnalytics: {
    gTag: ServerConfig.googleAnalytics.gTag,
  },
  hubspot: {
    collegeDemoUrl: ServerConfig.hubspot.collegeDemoUrl,
  },
  launchDarkly: {
    clientId: ServerConfig.launchDarkly.clientId,
  },
  mixpanel: {
    apiKey: '',
    sessionReplayPercent: 0,
  },
  supabase: {
    anonKey: ServerConfig.supabase.anonKey,
    url: ServerConfig.supabase.url,
  },
  stripe: {
    publicKey: '',
  },
  scoreboardLiveLearnMoreUrl: ServerConfig.scoreboardLiveLearnMoreUrl,
  helpCentreUrl: ServerConfig.helpCentreUrl,
  webAppUrl: '',
  intercom: {
    appId: ServerConfig.intercom.appId,
  },
};
